module.exports = __webpack_public_path__ + "img/why-energy.6478b1a.webp";